export const ERROR_MESSAGE_NO_ITEMS = "'files' should be array of items.";
export const ERROR_MESSAGE_SIZE = "'size' should be a number.";
